module.exports = __webpack_public_path__ + "img/twitter.76dd86c9.png";